<template>
  <div class="page-container">
    <header id="wapHeard" class="wapHeard" v-if="!isAPP">
      <a href="JavaScript:;" class="back-icon" v-if="isGift==0"></a>
      <span  @click="gob()" v-if="isGift==1">
        <a href="JavaScript:;" class="gob"></a>
      </span>
      <span  @click="goback()" v-if="isGift==2">
        <a href="JavaScript:;" class="gob"></a>
      </span>
      <div class="center">
        <slot name="title" v-if="isGift==0"></slot>
        <span v-if="isGift==1" class="tit">问题反馈</span>
        <span v-if="isGift==2" class="tit">规则说明</span>
      </div>
      <a href="JavaScript:;" class="tab-icon"></a>
    </header>
    <div class="menu-icon"></div>
    <slot name="content" v-if="isGift==0"></slot>
      <!--客服点击弹窗-->
      <div v-if="isGift==1" class="kefu-click-porp kefu-porp-main" style="display: none">
          <div class="kefu-list">
              <div class="kefu-div kefu1">
                  <a href="javascript:void (0);" id="qaOnline" style="display: inline-block;height: 100%;">在线客服</a>
              </div>
              <div class="kefu-div kefu2">
                  <a href="tel:4008077117" id="phoneCall" style="display: inline-block;height: 100%;">4008077117</a>
              </div>
              <div class="kefu-div kefu3">取消</div>
          </div>
      </div>
      <gift v-if="isGift==1" @goRules="goRules" @goListEvt="goListEvt" />
      <rule v-if="isGift==2" ></rule>
      <div class="feedback" @click="gifts()" v-show="isGift==0">
        <img class="gift" src="../../assets/images/gift.png" />
        反馈有奖</div>


         <!-- 第一次反馈弹框 -->
     <div class="popu-count" v-if="fristFlag">
        <div class="box">
         <p class="head">搜索反馈</p>
         <div style="height:2.6rem"></div>
         <p class="cent">感谢反馈，赠送您100积分！</p>
         <p class="hb"><img src="../../assets/img/b.png" /></p>
         <p class="txt">请前往个人中心_我的积分 中查看 </p>
         <p class="know" @click="fristFlag=false"><img src="../../assets/img/know.png" /></p>
     
          <p class="close" @click="fristFlag=false">
            <img src="../../assets/img/close.png" />
          </p>
        </div>
        
     </div>
  </div>
</template>
<script>
import gift from "../../pages/searchListM/components/gift/index.vue";
import rule from "../../pages/searchListM/components/gift/rule.vue";
export default {
  data() {
    return {
      wapMenuAndIcon: 'https://www.homedo.com/inc/wapMenuAndIcon.shtml',
      isAPP:false,
      isGift:0,
      fristFlag:false
    }
  },
  components:{
    gift,
    rule
  },
  mounted() {
    const vm = this
    $('.menu-icon').load(this.wapMenuAndIcon)
    setTimeout(function () {
      var byId = function (name) {
        return document.getElementById(name)
      }
      /* 浮动客服 */
      var oIconProp = byId('fixedIconProp')
      if (oIconProp) {
        window.addEventListener('scroll', function () {
          var w_t = window.scrollY
          w_t ? oIconProp.classList.add('cur') : oIconProp.classList.remove('cur')
        })
      }
      /* 在线客服处理 */
      var oIconKefu = byId('kefuOnlineNew')
      if (oIconKefu) {
        if ($HMD$.rNavigator == 'MiniProgram') {
          oIconKefu.remove()
          return false
        }
        oIconKefu.addEventListener('click', function () {
            $(".kefu-porp-main").show()
            $(".kefu-list").stop().animate({bottom:"0rem"},300,function (){

            })
            // OverallJsMobile.js里有公共调起客服的方法 所以注释掉下面的，同时有公共弹出收起客服选项的弹窗
          // $HMD$.M.lineXN(this.getAttribute('data-kefu'), this.getAttribute('data-appoint'))
        })
      }
      /* 电话客服处理 */
      var oIconPhone = byId('phoneCall')
      oIconPhone &&
        oIconPhone.addEventListener('click', function () {
          $HMD$.M.appEvent('callPhone')
        })
      /* 滚动到顶部 */
      var oIconScrollTop = byId('scrollTopBtn')
      oIconScrollTop &&
        oIconScrollTop.addEventListener('click', function () {
          window.scrollTo(0, 0)
        })
      /* 所属安卓或IOS需要处理的事件 */
      if ($HMD$.rNavigator == 'ios' || $HMD$.rNavigator == 'android') {
        vm.isAPP=true
        oIconPhone && (oIconPhone.href = 'JavaScript:;')
      }
    }, 100);
    this.isGift = sessionStorage.getItem("isGift")||0
    console.log("ppp7",this.isGift)
    if(this.isGift==0){
      $('body').css("background","#f5f5f5")
    }else{
      $('body').css("background","#ffffff")
    }
  },
  methods: {
    gifts(){
      let ticket = $HMD$.Cookie('ticket')||""
      console.log("0000===>",ticket.includes("fat_"))
      if (!$HMD$.Cookie('ticket')||ticket.includes("fat_")) {
                window.location.href = $HMD$.rApi['M'] + '/Account/Login?url=' + window.location.href
                return false
            }
       this.isGift = 1;
       //console.log("------->",$("#kefuOnlineNew"))
       sessionStorage.setItem("isGift",this.isGift)
       $("#kefuOnlineNew").css("display","none")
       $('body').css("background","#ffffff")
    },
    gob(){
        this.isGift = 0;
        console.log("phhhhhhhh555",this.isGift)
        $('body').css("background","#f5f5f5")
        $("#kefuOnlineNew").css("display","block")
        sessionStorage.removeItem("isGift")
    },
    goback(){
      this.isGift = 1;
      sessionStorage.setItem("isGift",this.isGift);
      $('body').css("background","#ffffff")
      },
    goRules(val){
        this.isGift = val;
        sessionStorage.setItem("isGift",this.isGift);
    },
    goListEvt(val){
      this.fristFlag = val;
      this.gob()
    }
  },
  destroyed() {
     
  },
}
/*
    * 下面的点击事件，在OverallJsMobile.js也有，这里再写一边的原因是因为再钉钉打开时候弹出不生效，原因未知
    * */
/* 客服弹窗取消点击 */
$(document).on('click',".kefu-porp-main,.kefu3",function (e) {
    $(".kefu-list").stop().animate({bottom:"-20rem"},200,function (){
        $(".kefu-porp-main").hide()
    })
});
/* 机器人点击调起客服弹窗 */
$(document).on('click',"#qaOnlineNew",function (e) {
    console.log('客服机器人点击！')
    $(".kefu-porp-main").show()
    $(".kefu-list").stop().animate({bottom:"0rem"},200,function (){

    })
});
</script>
<style lang="less" scoped>
.wapHeard {
  .center {
    padding: 1.05rem 4.4rem;
    box-sizing: border-box;
  }
}
.popu-count{
     position: fixed;
     z-index: 999;
     background: rgba(0,0,0,0.5);
     top:0;
     bottom: 0;
     left: 0;
     right: 0;
     .box{
        width: 27rem;
       // height: 22rem;
        background: #FFFBF3;;
        border-radius: 2rem;
        position: relative;
        left: 50%;
        top: 43%;
        transform: translate(-50%, -50%);
        border-radius: 1.5rem;
        padding: 1.6rem;
        .head{
           position: absolute;
           left:50%;
           transform: translateX(-50%);
           top:-1rem;
           width: 22rem;
           height: 4rem;
           background-image: url('../../assets/img/t.png');
           background-size: cover;
           text-align: center;
           font-size: 1.4rem;
           font-family: PingFangSC, PingFang SC;
           font-weight: 800;
           line-height: 4rem;
           color: #AB3014;
        }
        .cent{
            width: 27rem;
            height: 4rem;
            line-height: 4rem;
            font-size: 1.6rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #222222;
            text-align: center;
        }
        .hb{
            text-align: center;
            img{
                width:8rem;
                height: 8rem; 
            }
        }
        .txt{
            height: 2rem;
            font-size: 1.4rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            text-align: center;
            color: #666666;
            margin-bottom: 2.4rem;
            //line-height: 1.6rem;
        }
        .know{
            text-align: center;
            img{
                width:13rem;
                height: 3.6rem; 
            }
        }
        .close{
           position: absolute;
           left:50%;
           bottom: -6rem;
           transform: translateX(-50%);
           img{
            width: 4.5rem;
            height: 4.5rem;
           } 
        }
        
     }
   }
</style>
<style>
.kefu-porp-main{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, .5);
}
.kefu-list{
    position: fixed;
    right: 0;
    bottom: -20rem;
    z-index: 1001;
    width: 93%;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    text-align: center;
    font-size: 1.7rem;
}
.kefu-div{
    height: 4.9rem;
    line-height: 4.9rem;
    color: #2177FF;
    background: #FFFFFF;
}
.kefu-div a{
    color: #2177FF;
    width: 100%!important;
    position: inherit!important;
}
.kefu1{
    border-bottom: 1px solid #e5e5e5;
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
}
.kefu2{
    border-bottom-left-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
}
.kefu3{
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 1.6rem;
    border-radius: 0.2rem;
}
#qaOnlineNew,#scroll-top {
    width: 5rem;
    height: 5rem;
    right: 1.2rem;
}
#qaOnlineNew{
    position: fixed;
    z-index: 100;
    bottom: 14rem;
}
#scroll-top {
    bottom: 8rem!important;
    background: url(https://image01.homedo.com/Files/Images/cms/www/20230410/5196328958681146095_pic1.png) 0 0 no-repeat!important;
    background-size: 5rem 5rem !important;
}
.feedback {
    position: fixed;
    right: 0.6rem;
    top: 46rem;
    z-index: 6;
    width: 8.7rem;
    height: 3.6rem;
    background: #FFFFFF;
    box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.3);
    border-radius: 2.8rem;
    font-size: 1.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #292A2D;
    line-height: 4rem;
    padding: 0 0.8rem;
}
img.gift{
  width:2rem;
  height: 2rem;
  vertical-align: sub;
}
.gob{
    display: block;
    width: 2.4rem;
    height: 2.4rem;
    left: 1rem;
    background: url(https://image10.homedo.com/Mobile/icon.png) 0 0 no-repeat;
    background-size: 2.4rem;
}
.tit{
  width: 10.6rem;
  height: 3.6rem;
  font-size: 17px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #1E1F22;
  line-height:2.6rem;
}
</style>
